<template>
    <div class="min-h-screen flex items-center justify-center bg-gray-50 px-4 sm:px-6 py-8">
        <div class="max-w-md w-full bg-white border border-gray-200 rounded-2xl shadow-sm p-6 sm:p-10">
            <div class="w-12 h-12 sm:w-14 sm:h-14 mx-auto mb-5 sm:mb-6 rounded-full bg-cyan-600/10 flex items-center justify-center text-cyan-600">
                <svg class="w-6 h-6 sm:w-7 sm:h-7" fill="none" stroke="currentColor" stroke-width="1.8" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M16.5 10.5V6.75a4.5 4.5 0 10-9 0v3.75m-.75 0h10.5a2.25 2.25 0 012.25 2.25v6.75a2.25 2.25 0 01-2.25 2.25H6.75a2.25 2.25 0 01-2.25-2.25v-6.75a2.25 2.25 0 012.25-2.25z" />
                </svg>
            </div>

            <template v-if="!submitted">
                <h1 class="text-[22px] sm:text-[26px] font-semibold text-[#101414] mb-3 text-center">Esqueci minha senha</h1>
                <p class="text-[15px] sm:text-[16px] text-[#333A44] leading-[1.7] mb-6 sm:mb-8 text-center">
                    Digite seu e-mail e enviaremos um link para você redefinir sua senha.
                </p>

                <form @submit.prevent="submit">
                    <label class="block text-[16px] font-medium text-[#171717] mb-2.5">E-mail</label>
                    <input
                        type="email"
                        inputmode="email"
                        v-model="email"
                        maxlength="60"
                        placeholder="seuemail@email.com"
                        class="w-full h-[58px] px-4 mb-4 text-base bg-white border border-[#D9D9D9] rounded-xl text-[#171717] placeholder:text-gray-400 focus:outline-none focus:border-cyan-600 focus:ring-2 focus:ring-cyan-600/15 transition-colors"
                    />

                    <p v-if="errorMessage" class="text-red-500 text-sm mb-4">{{ errorMessage }}</p>

                    <button
                        type="submit"
                        :disabled="loading || !email"
                        class="inline-flex items-center justify-center w-full h-[52px] rounded-xl bg-cyan-600 text-white font-medium text-base hover:bg-cyan-700 disabled:opacity-60 transition-colors"
                    >
                        <svg v-if="loading" class="animate-spin mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                        {{ loading ? 'Enviando...' : 'Enviar link de redefinição' }}
                    </button>
                </form>

                <router-link
                    :to="{ name: 'login' }"
                    class="block text-center mt-6 text-[14px] font-medium text-cyan-600 hover:underline"
                >
                    Voltar ao login
                </router-link>
            </template>

            <template v-else>
                <h1 class="text-[22px] sm:text-[26px] font-semibold text-[#101414] mb-3 text-center">Verifique seu e-mail</h1>
                <p class="text-[15px] sm:text-[16px] text-[#333A44] leading-[1.7] mb-6 sm:mb-8 text-center">
                    Se esse e-mail estiver cadastrado, enviamos um link para redefinição de senha. Confira também sua caixa de spam.
                </p>
                <router-link
                    :to="{ name: 'login' }"
                    class="inline-flex items-center justify-center w-full h-[52px] rounded-xl bg-cyan-600 text-white font-medium text-base hover:bg-cyan-700 transition-colors"
                >
                    Voltar ao login
                </router-link>
            </template>
        </div>
    </div>
</template>

<script>
import { ref } from 'vue';
import AuthService from '../services/AuthService';

export default {
    name: 'ForgotPassword',
    setup() {
        const email = ref('');
        const loading = ref(false);
        const submitted = ref(false);
        const errorMessage = ref('');

        async function submit() {
            errorMessage.value = '';
            loading.value = true;
            try {
                await AuthService.forgotPassword(email.value.trim().toLowerCase());
                submitted.value = true;
            } catch (err) {
                errorMessage.value = 'Não foi possível enviar o link agora. Tente novamente em instantes.';
            } finally {
                loading.value = false;
            }
        }

        return { email, loading, submitted, errorMessage, submit };
    }
}
</script>
